
type aliveScopeType = ({
    drop: (args?: any) => void,
    dropScope:  (args?: any) => void,
    clear:  (args?: any) => void,
    getCachingNodes: any
}) | null | undefined
class GlobalConfig {
    private static instanceOfGlobal: GlobalConfig | null;
    private location: any = null;
    private navigate: any = null;
    private aliveScope: aliveScopeType = null;
    constructor( aliveScope?: aliveScopeType,location?: any,navigate?: any ) {
        if (GlobalConfig.instanceOfGlobal) {
            return GlobalConfig.instanceOfGlobal
        }
        this.aliveScope = aliveScope;
        this.location = location;
        this.navigate = navigate;
        GlobalConfig.instanceOfGlobal = this;
    }
    getLocation() {
        return this.location || {}
    }
    setLocation(location: Location) {
        this.location = location;
    }
    getNavigate() {
        return this.navigate || {}
    }
    setNavigate(navigate: any) {
        this.navigate = navigate;
    }
    getAliveScope() {
        return this.aliveScope
    }
    setAliveScope(aliveScope: aliveScopeType) {
        this.aliveScope = aliveScope
    }
    clear() {
        this.aliveScope?.clear()
        this.aliveScope = null
        this.location = null
        this.navigate = null
        GlobalConfig.instanceOfGlobal = null
    }
}
export default GlobalConfig